/**
 *
 * 模型树
 *
 * 功能点:共用模型树
 * 场景:方案演示
 * 版本 1.0
 *
 */
import Vue from "@/main";
import screenplayFn from "@/components/tables/program/screenplayFn.js";
/**
 * 模型变量
 * @var tiles3dLayer - 当前模型图层
 * @var checkeArr - 初始化模型id集合
 */
export let tiles3dLayer;
export let checkeArr = [];
let opacityIdArr = [];

/**
 * 初始化模型id集合赋值
 * @returns { any } - 初始化模型id集合赋值
 */
export function getCheckeArr(array) {
  checkeArr = array;
}

/**
 * 初始化模型
 * @returns { any } - 返回当前map上模型对象
 */
export function initial() {
  if (tiles3dLayer) tiles3dLayer.remove();
}

/**
 * 添加模型
 * @param  { object } data - 模型对象
 * @param  { object } type - 添加模型时候的类型=> 当type等于resourceRelease时候是读取的viewShed动态加载的数据 (viewShed中数据结构不同)！！！！
 * @param  { function } fn - 模型加载成功的回调
 * @param  { function } clickFn - 模型点击成功的回调
 * @returns { object } - 返回当前map上模型对象
 */
export function addModel(data, type, fn, clickFn) {
  console.log(
    "初始化模型默认染色",
    data.bimModel.modelColor,
    data.title,
    ifModel(data.id)
  );
  if (ifModel(data.id)) {
    return ifModel(data.id);
  } else {
    let modelId,
      bimModelExcavationDetails,
      permission,
      url,
      modelType,
      modelTitle,
      modelColor;
    if (type == "resourceRelease") {
      modelId = data.modelId;
      permission = data.permission;
      url = data.url;
      modelType = data.modelType;
      modelTitle = data.modelTitle;
    } else {
      modelId = data.id;
      bimModelExcavationDetails = data.bimModelExcavationDetails;
      permission = data.bimModel.isDynamicReleased;
      url =
        Vue.$GLOBAL.projectBaseUrl +
        Vue.$GLOBAL.modelBasePort +
        data.bimModel.modelUrl;
      modelType = data.bimModel ? data.bimModel.modelType : null;
      modelTitle = data ? data.title : null;
    }
    modelColor = data.bimModel.modelColor
      ? data.bimModel.modelColor
      : undefined;

    if (modelColor && modelColor != undefined && modelColor != "null") {
      tiles3dLayer = new mars3d.layer.TilesetLayer({
        modelId: modelId,
        modelType: modelType,
        modelTitle: modelTitle,
        modelColor: modelColor,
        permission: permission,
        customize: {
          bimModelExcavationDetails: bimModelExcavationDetails,
        },
        url: encodeURI(url),
        style: {
          color: {
            conditions: [["true", modelColor]],
          },
        },
        maximumScreenSpaceError: 16,
        maximumMemoryUsage: 1024,
        flat: {
          precise: true,
          old: true,
        },
        skipLevelOfDetail: true,
        loadSiblings: true,
        cullRequestsWhileMoving: true,
        cullRequestsWhileMovingMultiplier: 10,
        preferLeaves: true,
        progressiveResolutionHeightFraction: 0.5,
        dynamicScreenSpaceError: true,
        preloadWhenHidden: false,
        popup: `&nbsp;&nbsp; ${modelTitle} &nbsp;&nbsp;`,
        clip: { enabled: true, precise: true },
      });
    } else {
      tiles3dLayer = new mars3d.layer.TilesetLayer({
        modelId: modelId,
        modelType: modelType,
        modelTitle: modelTitle,
        permission: permission,
        customize: {
          bimModelExcavationDetails: bimModelExcavationDetails,
        },
        url: encodeURI(url),
        maximumScreenSpaceError: 16,
        maximumMemoryUsage: 1024,
        flat: {
          precise: true,
          old: true,
        },
        skipLevelOfDetail: true,
        loadSiblings: true,
        cullRequestsWhileMoving: true,
        cullRequestsWhileMovingMultiplier: 10,
        preferLeaves: true,
        progressiveResolutionHeightFraction: 0.5,
        dynamicScreenSpaceError: true,
        preloadWhenHidden: false,
        popup: `&nbsp;&nbsp; ${modelTitle} &nbsp;&nbsp;`,
        clip: { enabled: true, precise: true },
      });
    }
    tiles3dLayer.bindHighlight({
      //all:true,
      type: mars3d.EventType.click, // 默认为鼠标移入高亮，也可以指定click单击高亮
      color: "#FF0000",
    });
    tiles3dLayer.on(mars3d.EventType.load, (event) => {
      if (event.layer.options.modelType == 0) {
        let index = Vue.$GLOBAL.osgbTilesetLayerIds.indexOf(
          event.layer.options.modelId
        );
        if (index < 0) {
          Vue.$GLOBAL.osgbTilesetLayerIds.push(event.layer.options.modelId); //记录倾斜摄影id数组
        }
      }
      if (fn) fn(event);
    });
    tiles3dLayer.on(mars3d.EventType.click, function (event) {
      // // try {
      // console.log(event);
      // tiles3dLayerAdd.openHighlight(
      //   {
      //     color: "rgba(255,0,0,1)",
      //   },
      //   true,
      //   event.pickedObject
      // );
      // } catch (error) {
      // console.log(error);
      // }
      if (clickFn) clickFn(event);
    });

    Vue.$GLOBAL.map.addLayer(tiles3dLayer);
    // tiles3dLayer = tiles3dLayerAdd;
    return tiles3dLayer;
  }
}

/**
 * 移除模型
 * @param  { object } data - 模型对象
 * @returns { any } - 返回当前map上模型对象
 */
export function deleteModel(data) {
  if (data != "all") {
    viewShed.inquire("modelArray", "modelId", data.options.modelId) != undefined
      ? (viewShed.inquire("modelArray", "modelId", data.options.modelId).uid =
          "")
      : "";
    // let index = Vue.$GLOBAL.osgbTilesetLayerIds.indexOf(data.options.modelId);
    // if (index >= 0) {
    //   Vue.$GLOBAL.osgbTilesetLayerIds.splice(index, 1);
    // }
    Vue.$GLOBAL.map.removeLayer(data); //移除layer。
  } else {
    console.log(Vue.$GLOBAL.ptDataList);
    let getLayersId = [];
    console.log("移除所有", checkeArr, getLayersId);
    // 删除不是初始的模型
    Vue.$GLOBAL.map.getLayers().forEach((item) => {
      if (item.type == "3dtiles") {
        if (checkeArr.indexOf(item.options.modelId) < 0) {
          deleteModel(item);
        } else {
          getLayersId.push(item.options.modelId);
        }
      }
    });
    // 添加初始的模型
    // 求差
    viewShed.difference(checkeArr, getLayersId).forEach((item) => {
      screenplayFn.model.show("add", item);
    });
    // 求交
    viewShed.intersection(checkeArr, getLayersId).forEach((item) => {
      // 默认颜色
      let defaultColor = ifModel(item).options.modelColor,
        currentColor;
      // if (defaultColor && defaultColor != undefined) {
      currentColor =
        ifModel(item).layer.style?.color._conditions != undefined
          ? ifModel(item).layer.style?.color._conditions[0][1]
          : null;
      if (currentColor != defaultColor) {
        if (defaultColor && defaultColor != undefined) {
          ifModel(item).layer.style = new Cesium.Cesium3DTileStyle({
            color: {
              conditions: [["true", defaultColor]],
            },
          });
        } else {
          ifModel(item).opacity = 1;
        }
      }
      // }
    });
  }
}

/**
 * 定位模型 飞跃 高亮
 * @param  { object } data - 模型对象
 * @param  { string } color - 飞行后的颜色
 * @returns { any }
 */
export function positioningModel(data, color) {
  data.flyTo({
    duration: 3,
  });
  if (color)
    data.openHighlight(
      {
        color: color,
      },
      true
    );
}

/**
 * 判断模型是否再地图上
 * @param  { string } id - 模型对象
 * @param  { string } type - 查找对象的key 默认是 modelId
 * @returns { object | boolean } - 返回当前map上模型对象 如果不存在就是 false
 */
export function ifModel(id, type = "modelId") {
  let item = false;
  if (
    Vue.$GLOBAL.map.getLayer(id, type) &&
    Vue.$GLOBAL.map.getLayer(id, type) != undefined
  ) {
    item = Vue.$GLOBAL.map.getLayer(id, type);
  }
  return item;
}

/**
 * 模型染色
 * @param  { string } type - 类型 整体overall 局部local 混合mix
 * @param  { object } id - 模型id
 * @param  { array } color - 颜色参数
 * @returns { any }
 */
export function dyeing(type = "overall") {
  console.log("透明度");
  switch (type) {
    case "overall":
      return (color, id, fn, ...list) => {
        let map = Vue.$GLOBAL.map;
        if (list.length > 0) {
          let { mapType } = list[0];
          if (mapType == "clone") {
            map = Vue.$GLOBAL.mapClone;
          }
        }
        let layer = map.getLayer(id, "modelId");
        if (layer && layer != undefined) {
          if (!isNaN(parseFloat(color))) {
            layer.opacity = color;
          } else {
            layer.style = {
              color: {
                conditions: [["true", color]],
              },
            };
          }
        } else {
        }
      };
    case "local":
      break;
    case "mix":
      break;
  }
}

/**
 * 模型透明度
 * @param  { string } value - 透明度
 * @param  { object } id - 模型id
 * @param  { function } fn - 回调函数
 * @param  { array } list - 自定义字段
 * @returns { any }
 */
export function opacity(value, id, fn, ...list) {
  let map = Vue.$GLOBAL.map;
  if (list.length > 0) {
    let { mapType } = list[0];
    if (mapType == "clone") {
      map = Vue.$GLOBAL.mapClone;
    }
  }

  let layer = map.getLayer(id, "modelId");

  if (layer && layer != undefined) {
    layer.opacity = value;
  }
  allModelsLoaded(map, {
    opacityValue: value,
  });
}

/**
 * 监听所有模型加载完成
 * @returns { any }
 */
export function allModelsLoaded(map, ...list) {
  let { opacityValue } = list[0];
  map.once(mars3d.EventType.postRender, (event) => {
    opacityIdArr.forEach((id) => {
      let layer = map.getLayer(id, "modelId");
      if (layer && layer != undefined) {
        if (layer.style != undefined) {
          let rgba = `rgba(${
            layer.style.color.conditions[0][1]
              .split("rgba")[1]
              .match(/(\d(\.\d+)?)+/g)[0]
          },${
            layer.style.color.conditions[0][1]
              .split("rgba")[1]
              .match(/(\d(\.\d+)?)+/g)[1]
          },${
            layer.style.color.conditions[0][1]
              .split("rgba")[1]
              .match(/(\d(\.\d+)?)+/g)[2]
          },${opacityValue})`;
          console.log(rgba);
          layer.style = {
            color: {
              conditions: [["true", rgba]],
            },
          };
        } else {
          layer.opacity = opacityValue;
        }
        // layer.style = {
        //   color: {
        //     conditions: [["true", "rgba(255,128,0,1)"]],
        //   },
        // };
      }
    });
  });
  // if (!map.listens(mars3d.EventType.addLayer)) {
  //   map.on(mars3d.EventType.addLayer, (event) => {
  //     console.log("透明？", opacityIdArr, event.layer.options.modelId);
  //   });
  // }
}
